import React, { Fragment } from 'react';
import { Redirect } from 'react-router-dom';

import './AuthView.scss';
import Validator from 'RLX/Forms/Validator';
import LoginForm from 'Auth/Forms/LoginForm';
import RegistrationForm from 'Auth/Forms/RegistrationForm';
import Store from 'RLX/State/Store';
import { handleError } from 'RLX/State/Ui/UiActions';
import { attemptLogout } from 'RLX/State/Auth/AuthActions';

import { visibleIf } from 'Core/Utils';

class AuthView extends React.Component {
  constructor (props) {
    super(props);
    const { auth } = Store.getState();
    this.state = { ...auth };
    this.renderLoader = this.renderLoader.bind(this);
    this.getCurrentPath = this.getCurrentPath.bind(this);
    this.renderAuthError = this.renderAuthError.bind(this);
    this.componentDidCatch = this.componentDidCatch.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = Store.subscribe(() => {
      const { auth } = Store.getState();
      this.setState({ ...auth });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  componentDidCatch (error, info) {
    handleError(error, info);

    return null;
  }

  renderLoader () {
    const active = this.state.loading;
    return (
      <div className={'row AuthView-Loader ' + (active ? 'active' : 'inactive')}>
        <img src="assets/load-black.gif" />
      </div>
    );
  }

  renderAuthError () {
    const { errorMessage } = this.state;
    const message = <div dangerouslySetInnerHTML={{ __html: errorMessage }} />;
    return (
      <Validator
        closeable={true}
        visible={errorMessage}
        message={message}
      />
    );
  }

  renderForm ({ path, children = null }) {
    switch (path.toLowerCase()) {
      case 'register':
        return <RegistrationForm children={children} />
      case 'login':
        return <LoginForm children={children} />
      default:
        return null;
    };
  }

  renderCopy ({ path = '' }) {
    const copy = {
      logout: null,
      login: (
        <p>
          Please log in with your RLX credentials.
          <br />
          Registration is open to <strong>rocklititz.com</strong> emails.
        </p>
      ),
      register: (
        <p>Register here for access to <b>RLX</b>.</p>
      )
    };
    return (path && path in copy) ? copy[path] : null;
  }

  getCurrentPath () {
    const { match } = this.props;
    const path = match.url
      .substring('/RLX/'.length)
      .split('/')
      .filter(x => x)
      .join('/');
    return path;
  }

  render () {
    const { loading, errorMessage, loggedIn } = this.state;

    const path = this.getCurrentPath();

    const Err = this.renderAuthError;
    const Loader = this.renderLoader;
    const AuthCopy = this.renderCopy;
    const AuthForm = this.renderForm;

    return (
      <div className="AuthView">
        <main className="AuthView-Body">
          <img src="/assets/RLX.png" className="Logo" />
          <div style={visibleIf(!loading)} className="AuthView-Copy">
            <AuthCopy path={path} />
          </div>
          <AuthForm path={path}>
            <Err />
            <Loader />
          </AuthForm>
        </main>
      </div>
    );
  }
};

export default AuthView;



// WEBPACK FOOTER //
// ./client/RLX/Views/Auth/AuthView.jsx